import { ACTIONS_DELETED_ELEM } from './../../../constants/actions.constants';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges, ViewChild, afterNextRender, ChangeDetectorRef, ChangeDetectionStrategy, inject, Injectable, output, TemplateRef, OnDestroy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { debounceTime, merge, Subject, Subscription } from 'rxjs';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateData, PaginateOptions } from '../../../utils/paginate.utils';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Modal } from '../modal/modal.component';
import { MatCardModule } from "@angular/material/card";
import { Button } from '../button/button.component';
import { ActionInterface } from '../../../constants/actions.constants';
import { CommonModule } from '@angular/common';
import { BaseSelectService } from '../../../core/BaseSelect.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ColumnNames } from '../../../constants/form.constants';

import { OneToNo , NullToNo, SiNoUniversal} from '../../../utils/formatData.pipe';
import { Select } from '../select/select.component';
import { ApiService } from '../../../core/api.service';
import { ActivatedRoute } from '@angular/router';
import { AutocompleteFieldComponent } from '../autocomplete-field/autocomplete-field.component';
/**
 * @title Basic use of `<table mat-table>`
 */
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-table',
  styleUrl: 'table.scss',
  templateUrl: 'table.html',
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatPaginator,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatTooltip,
    MatCardModule,
    Button,
    CommonModule,
    MatCheckboxModule,
    OneToNo,
    NullToNo,
    SiNoUniversal,
    MatProgressSpinnerModule,
    AutocompleteFieldComponent

  ],
  standalone: true,
})
export class Table<T> implements AfterViewInit, OnChanges , OnDestroy{

  private firstLoad = true;

  isLoading = false;

  skip = 0;
  take: number = 50;
  private activatedRoute = inject(ActivatedRoute);
  valueSelected!: number;
  globalFilterValue!:string;
  spinner : boolean = false;
  isLoadingAllData = false;
  @Input() mainFilterField!:string;
  @Input() columnsNames!: ColumnNames[];
  @Input() paginateOptions:PaginateOptions = { ...DEFAULT_PAGINATE_OPTIONS_LIST };
  private _dataFetch: PaginateData<T> | null = null;
  @Input()
  set dataFetch(value: PaginateData<T> | null) {
    if (this.firstLoad) {
      this.isLoadingAllData = true;
      this._dataFetch = value;
      this.isLoadingAllData = false;
      this.firstLoad = false;
    } else {
      this._dataFetch = value;
      this.isLoadingAllData = false;
    }
  }
  get dataFetch(): PaginateData<T> | null {
    return this._dataFetch;
  }
  @Input() totalItems!: number;
  @Input() actions !: { [name: string]: ActionInterface };
  @Input() actionsDeletedItems : { [name: string]: ActionInterface } = ACTIONS_DELETED_ELEM;
  @Input() selectedValue!: number
  @Input() dataSelect!: { value: number; label: string }[];
  @Input() labelFilter!: string;
  @Output() emitValueSelected = new EventEmitter<number>
  //styles
  @Input() height: string = 'auto';
  @Input() width: string = 'auto';
  @Input() order: boolean = true;
  @Input() pageSize!: number;
  @Input() pagination: boolean = true;
  @Input() clickable: boolean = false;
  @Input() filterable: boolean = false;
  @Input() selectable: boolean = false;
  @Input() templateRef!: TemplateRef<any>;
  @Input() templateRefExtraButtons!: TemplateRef<any>;
  @Input() showExtraButtonsTemplateRef!: boolean;
  @Input() labelSelect!: string;
  @Input() customActionTittle!: string;
  searchInput = new Subject<string>();
  private subscriptions: Subscription[] = [];

  //fetch again is used when a page is changed
  @Output() fetchAgain = new EventEmitter<{ options: PaginateOptions; ignoreCache: boolean }>();

  //here we use ViewChild to get references to the paginator, sort and filter input elements
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatInput) filter!: MatInput;
  clickedRows = new Set<T>();
  dataRowsClicked: PaginateData<T> = { data: [], total_items: 0 };
  @Output() returnClickedRows = new EventEmitter<PaginateData<T>>();
  @Output() returnActionEvent = new EventEmitter<number>();
  @Output() callCustomFunction = new EventEmitter<any>();
  //here we inject the Modal service and BaseSelectService
  private modal = inject(Modal);
  private selectService = inject(BaseSelectService);
  @Input() apiService!: any;
  rowIsSelected: boolean = false;
  filterBy !:string[];

  @Input() pageIndex: number = 0;
  private cdr = inject(ChangeDetectorRef);
  ngOnChanges(changes: SimpleChanges): void {
    // Apagar loading si llegan nuevos datos
    if (changes['dataFetch'] && changes['dataFetch'].currentValue !== changes['dataFetch'].previousValue) {
      setTimeout(() => {
        this.isLoading = false;
      }, 120); // pequeño delay para que el spinner sea visible
    }
    // Resetear paginador si cambia el valor seleccionado
    if (changes['selectedValue'] && this.paginator) {
      this.paginator.pageIndex = 0;
    }
    if (changes['pageIndex']) {
      if (this.paginator && changes['pageIndex'].currentValue !== undefined) {
        console.log(`Table: pageIndex changed to ${changes['pageIndex'].currentValue}`);
        this.paginator.pageIndex = changes['pageIndex'].currentValue;
        this.cdr.detectChanges()
        console.log(`Table: paginator pageIndex set to ${this.paginator.pageIndex}`);
      }
    }
  }
  ngOnInit() {
    this.columnsNames = this.columnsNames ? [...this.columnsNames] : [];
    const actionColumn = { name: "actions", label: "acciones" };
    if (!this.columnsNames.find((c) => c.name === actionColumn.name)) {
      this.columnsNames.push(actionColumn);
    }
    this.filterBy = this.columnsNames.filter((column)=>{
      return column.allowFilter;
    }).map((column)=>{
      return column.name
    })
    // Recibir take y skip desde query params
    const querySub = this.activatedRoute.queryParams.subscribe(params => {
      if (params['take']) this.take = +params['take'];
      if (params['skip']) this.skip = +params['skip'];
    });
    this.subscriptions.push(querySub);
    const searchSub = this.searchInput.pipe(
      debounceTime(300)
    ).subscribe((searchTerm: string) => {
      this.isLoading = true;
      this.applyFilter(searchTerm);
    });
    this.subscriptions.push(searchSub);
  }

  get columnKeys(): string[] {
    return this.columnsNames ? this.columnsNames.map((c) => c.name) : [];
  }

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.paginator.pageIndex = this.pageIndex;
      console.log(`Table: Setting paginator pageIndex to ${this.paginator.pageIndex} on AfterViewInit`);
    }
    if (this.paginator && this.sort) {
      const selectSub = this.selectService.getValue().subscribe((data) => {
        this.paginator.pageIndex = 0;
      });
      this.paginator.pageIndex = this.pageIndex;
      this.subscriptions.push(selectSub);
      if (this.pageSize) {
        this.paginator.pageSize = this.pageSize;
      }
      const sortSub = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      this.subscriptions.push(sortSub);
      const mergeSub = merge(this.sort.sortChange, this.paginator.page)
      .subscribe(() => {
        this.isLoading = true;
        setTimeout(() => {
          this.paginateOptions.skip = (this.paginator.pageIndex) * this.paginator.pageSize;
          this.paginateOptions.take = this.paginator.pageSize;
          this.paginateOptions.order = this.sort.active ?? this.paginateOptions.order;
          this.paginateOptions.direction = this.sort.direction || 'ASC';
          this.paginateOptions.mainValueToFilter = this.valueSelected || '';
          this.paginateOptions.globalFilterValue = this.globalFilterValue || '';
          //actualizo el skip y take para mantener la misma pagina al realizar una accion
          this.skip = this.paginateOptions.skip;
          this.take = this.paginateOptions.take;
          this.fetchAgain.emit({ options: { ...this.paginateOptions }, ignoreCache: false });
        }, 80);
      });
      this.subscriptions.push(mergeSub);
    }
  }
  openDialog(actionName: string, id: number , showActionsButtons: boolean = true , modalSize: 'small' | 'medium' | 'large' = 'medium') {
    const dialogRef = this.modal.openDialog(actionName, id, this.templateRef, showActionsButtons , this.customActionTittle, modalSize);
    this.callCustomFunction.emit({action:actionName , id:id})
    const dialogSub = dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return;
      if (result.action === 'delete' && result.id) {
        const deleteSub = this.apiService.delete(result.id, result.motivo, result.comment).subscribe(() => {
          this.apiService.clearCache(); // Limpiar cache después de eliminar un elemento
          this.fetchAgain.emit({ options: { ...this.paginateOptions , skip: this.skip, take: this.take }, ignoreCache: true });
        });
        this.subscriptions.push(deleteSub);
      } else if (result.action === 'restore' && result.id) {
        const restoreSub = this.apiService.restore(result.id, result.comment).subscribe(() => {
          this.apiService.clearCache(); // Limpiar cache después de restaurar un elemento
          this.fetchAgain.emit({ options: { ...this.paginateOptions , skip: this.skip, take: this.take }, ignoreCache: true });
        });
        this.subscriptions.push(restoreSub);
      } else {
        this.returnActionEvent.emit(id);
      }
    });
    this.subscriptions.push(dialogSub);
  }
  selectRow(row: T) {
    if (!this.clickedRows.has(row)) {
      this.clickedRows.add(row);
      this.dataRowsClicked.data.push(row);
      this.dataRowsClicked.total_items++;
    } else {
      this.clickedRows.delete(row);
      this.dataRowsClicked.data.pop();
      this.dataRowsClicked.total_items--;
    }
    this.returnClickedRows.emit(this.dataRowsClicked);
  }
  deleteRow(row:T){
    this.clickedRows.delete(row);
    this.dataRowsClicked.data = this.dataRowsClicked.data.filter((elem , index)=> {
      return elem !== row
    });
    this.returnClickedRows.emit(this.dataRowsClicked);
  }
  clearAllSelectRow() {
    this.clickedRows.clear();
    this.dataRowsClicked = {
      data: [],
      total_items: 0
    };
    this.returnClickedRows.emit(this.dataRowsClicked);
  }
  customFunction(row: T){
    this.callCustomFunction.emit(row);
  }
  onSearchInputChange(searchTerm: string) {

    this.searchInput.next(searchTerm);
  }

  applyFilter(searchTerm: string) {
    this.globalFilterValue = searchTerm;
    const paginateOptions:PaginateOptions = {skip:0,take:this.paginator.pageSize, globalFilterValue:searchTerm , ignoreCache:false}
    if(this.valueSelected){
      paginateOptions.mainValueToFilter = this.valueSelected;
    }
    this.fetchAgain.emit({ options: paginateOptions, ignoreCache: false });
  }

  selectValue(value: number) {
    this.valueSelected = value;
    this.selectService.setValue(value)
    this.emitValueSelected.emit(this.valueSelected)
    if(this.valueSelected == 0 ){
      this.fetchAgain.emit({ options: { ...this.paginateOptions , skip: this.skip, take: this.take }, ignoreCache: false });
    }else{
      this.fetchAgain.emit({ options: { skip: this.skip, take: this.take, mainFilterField: this.mainFilterField, mainValueToFilter: this.valueSelected }, ignoreCache: false });
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.searchInput.complete();
  }
}

